import React, { useRef } from "react";
import { Col, Row } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import BootstrapTable from "src/components/BootstrapTable";
import CheckedButton from "src/components/CheckedButton";
import Title from "src/components/Title";
import API from "src/services/api";
import TableFormatter from "src/utils/tableFormatter";

const SuggestChangesSite = () => {
  const navigate = useNavigate();
  const table = useRef();

  const setSuggestChangesAsDone = async (suggestChangeId) => {
    if (window.confirm("Änderungsvorschlag als erledigt markieren?")) {
      await API.setSuggestChangesAsDone(suggestChangeId);
      table.current.refresh();
    }
  };

  return (
    <React.Fragment>
      <Row>
        <Col>
          <Title>Vorschläge für Änderungen</Title>
        </Col>
      </Row>
      <Row>
        <Col>
          <BootstrapTable
            url="/api/backend/suggestchanges"
            sort="created_at"
            order="asc"
            ref={table}
            showSearch
            showClear
            showRefresh
            showFilter
            cache
            pageSize={25}
            pageSizes={[25, 50, 100, 250]}
            columns={[
              {
                field: "swipe_id",
                name: "Swipe-ID",
                sortable: true,
                filterControl: "input",
                formatter: (value) => {
                  return <Link to={`/swipe/check/${value}`}>{value}</Link>;
                },
              },
              {
                field: "type",
                name: "Typ",
                sortable: true,
                filterControl: "input",
              },
              {
                field: "comment",
                name: "Kommentar",
                sortable: true,
                filterControl: "input",
              },

              {
                field: "created_at",
                name: "Erstellt am",
                sortable: true,
                formatter: TableFormatter.formatDateTime,
              },
              {
                field: "id",
                textAlign: "right",
                width: 120,
                formatter: (value) => {
                  return (
                    <React.Fragment>
                      <CheckedButton
                        onClick={() => setSuggestChangesAsDone(value)}
                      />
                    </React.Fragment>
                  );
                },
              },
            ]}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default SuggestChangesSite;
